if (document.querySelector('#stack')) {
  const links = document.querySelectorAll('#stack #floor-links .floor-link')

  links.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault()

      const activeFloor = document.querySelector(
        '#stack #floor-links .floor-link.active'
      )
      const activePlan = document.querySelector(
        '#stack #floor-plans .floor-plan.active'
      )

      activeFloor.classList.remove('active')
      activePlan.classList.remove('active')

      const floor = e.target.dataset.floor
      const floorLink = document.querySelector(
        `#stack #floor-links .floor-link[data-floor="${floor}"]`
      )
      const floorPlan = document.querySelector(
        `#stack #floor-plans .floor-plan[data-floor="${floor}"]`
      )

      floorLink.classList.add('active')
      floorPlan.classList.add('active')
    })
  })
}
